import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.GenderContentsCountPieChartView extends Monitoring.Views.Charts.PieChartView

  customChartOptions: ->
    return {
      colors: ['#FF99CC', '#66CCFF', '#F3F781', '#9E9E9E']
    }

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.gender_contents_count')
    @title_en = I18n.t('monitoring.dashboard.charts.gender_contents_count', {'locale': 'en'})
    super(@options)
    @name = 'enhanced_gender'

  getNewQuery: (event) ->
    name = event.point.code || event.point.name
    query = @searchQuery.deepCopy()
    query.set('enhanced_gender', [ name ])
    return query

  getPieData: (name) ->
    return [
      ['female', @getCount(name, 'female')],
      ['male', @getCount(name, 'male')],
      ['unknown', @getCount(name, 'unknown')],
      ['no gender', @getCount(name, 'no gender')],
    ]

  getCount: (facet_name, term_name) ->
    facet = _.find(@facets[facet_name]['terms'], (facet) ->
      facet.term == term_name
    )
    return if facet then facet.count else 0

  benchmarkChartOptions: (currentBenchmark) ->
    series = @_getOptions().series

    benchmark_series = $.extend({}, series[0])
    benchmark_series.data = $.extend([], @_benchmarkDataFromResponse())

    indexOfMissing = _.findIndex(benchmark_series.data, {code: 'missing'})
    if indexOfMissing > -1
      benchmark_series.data[indexOfMissing].code = 'no gender'
      benchmark_series.data[indexOfMissing].name = 'no gender'

    sorted_benchmark_data = []
    for group in series[0].data
      indexOfGroup = _.findIndex(benchmark_series.data, {code: group.name})
      if indexOfGroup > -1
        benchmark_series.data[indexOfGroup].name = benchmark_series.data[indexOfGroup].code
        sorted_benchmark_data.push(benchmark_series.data[indexOfGroup])
      else
        sorted_benchmark_data.push({code: group.name, y: 0})
    benchmark_series.data = sorted_benchmark_data
    options = $.extend(true, @_getOptions(), @_getChartOptions())
    options.title = {text: currentBenchmark, y: 30, align: 'left', x: 10, floating: true}
    options.title.style = {fontSize: '13px', fontWeight: 'bold'}
    options.series = [benchmark_series]
    options.chart.renderTo = @$el.find('.benchmark-chart')[0]
    return options
